import "./Message.css";
import profile from "../../assets/ullas.jpg";
import { FaShare } from "react-icons/fa";
import { AiOutlineMessage } from "react-icons/ai";
import { AiOutlineLink } from "react-icons/ai";
import { BiMicrophone } from "react-icons/bi";

export default function Message() {
  return (
    <div className="message__container viewp">
      <div className="message__container-header">
        <div className="message__container-header__title">Messages</div>
        <div className="message__container-header-icons">
          <FaShare />
          <AiOutlineMessage />
        </div>
      </div>
      <div className="message__container-body">
        <div className="message__container-body__md">
          <div className="message__stack">
            <div className="m__user-stack">
              <div class="list">
                <img src={profile} alt="" />
                <div class="info">
                  <span class="user">Mr Awesome</span>
                  <span class="text">Hi! :)</span>
                </div>
                <span class="count">20</span>
                <span class="time">now</span>
              </div>
              <div class="list">
                <img src={profile} alt="" />
                <div class="info">
                  <span class="user">Mr Awesome</span>
                  <span class="text">Hi! :)</span>
                </div>
                <span class="count">20</span>
                <span class="time">now</span>
              </div>
              <div class="list">
                <img src={profile} alt="" />
                <div class="info">
                  <span class="user">Mr Awesome</span>
                  <span class="text">Hi! :)</span>
                </div>
                <span class="count">20</span>
                <span class="time">now</span>
              </div>
              <div class="list">
                <img src={profile} alt="" />
                <div class="info">
                  <span class="user">Mr Awesome</span>
                  <span class="text">Hi! :)</span>
                </div>
                <span class="count">20</span>
                <span class="time">now</span>
              </div>
              <div class="list">
                <img src={profile} alt="" />
                <div class="info">
                  <span class="user">Mr Awesome</span>
                  <span class="text">Hi! :)</span>
                </div>
                <span class="count">20</span>
                <span class="time">now</span>
              </div>
            </div>
          </div>
          <div className="message__viewport">
            
          </div>
        </div>
        <div className="messsage__container-writeblock">
          <div className="message__container-write__istyping">
            <div className="is__typing-user">
              <img src={profile} alt="" />
            </div>
            <span>Ullas</span>
            <span className="istyping">is typing...</span>
          </div>

          <div className="message__container-write">
            <input type="text" placeholder="Your Message..." />
            <div className="chat-icons">
              <AiOutlineLink />
              <BiMicrophone />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
